var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReviewIconColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "20px",
    viewBox: "0 -960 960 960",
    width: "20px",
    fill: "#0b4825",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480-96v-96q-140.33 0-238.16-97.77-97.84-97.77-97.84-238Q144-668 241.89-766t238.29-98q70.2 0 131.01 26.5Q672-811 717.5-765.5t72 106.37Q816-598.27 816-528q0 69-29.5 134t-77 121Q662-217 602-171.5T480-96Zm72-128q80-60 136-139.5T744-528q0-109-77.5-186.5T480-792q-109 0-186.5 77.5T216-528q0 109 77.5 186.5T480-264h72v40Zm-72-112q16.59 0 28.29-11.71Q520-359.41 520-376t-11.71-28.29Q496.59-416 480-416t-28.29 11.71Q440-392.59 440-376t11.71 28.29Q463.41-336 480-336Zm-29-122h58q0-26 4-39.5t23-32.5q18-17 36-36t18-54q0-48-32-74t-78-26q-41.88 0-70.44 24Q381-672 370-640l52.33 22q4.67-17 18.16-32T480-665q27 0 39.5 15t12.5 32q0 21-14.5 35.5T486-552q-26 24-30.5 41.5T451-458Zm29-50Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewIconColor);
export default __webpack_public_path__ + "static/media/reviewIconColor.a92449a07880583e8fc7cfc66a99b1dc.svg";
export { ForwardRef as ReactComponent };